import { environment } from "@wms/app";
import {
    CapitalizePipe, ContainerComponent, CustomPipe,
    FileExtensionFromMimePipe,
    FileIconClassPipe,
    FileSizePipe,
    FilterPipe, ImagePipe,
    NumberToStringPipe, OrderByPipe,
    PrefixPipe, SanitizePipe,
    StateClassPipe, StringToNumberPipe,
    SuffixPipe, TemplateFilter,
    TimeFromNowPipe,
    ToCurrencyPipe,
    ToDatePipe,
    ToNumberPipe, TrailingZeroDecimalPipe, TrustAsPipe, TemplateReplacePipe
} from "@wm/components-base";
import {
  AccordionDirective,
  AccordionpaneComponent,
  AlertDialogComponent,
  AnchorComponent,
  AudioComponent,
  BreadcrumbComponent,
  ButtonComponent,
  ButtonGroupDirective,
  CalendarComponent,
  CaptionPositionDirective,
  CardComponent,
  CardContentComponent,
  CardFooterDirective,
  CarouselDirective,
  CarouselTemplateDirective,
  CustomWidgetContainerDirective,
  ChartComponent,
  CheckboxComponent,
  CheckboxsetComponent,
  ChipsComponent,
  ColorpickerComponent,
  CompositeDirective,
  ConfirmDialogComponent,
  ContentComponent,
  CurrencyComponent,
  DateComponent,
  DateTimeComponent, DesignDialogComponent,
  DialogFooterDirective,
  FileuploadComponent,
  FooterComponent, FormActionDirective, FormComponent, FormFieldDirective,
  HeaderComponent,
  HtmlDirective,
  IconComponent,
  IframeComponent, IframeDialogComponent,
  LabelDirective,
  LayoutGridColumnDirective,
  LayoutGridDirective,
  LayoutGridRowDirective,
  LeftPanelComponent,
  ListComponent,
  ListenPropertyDirective,
  ListItemDirective, LiveFilterDirective, LiveFormDirective,
  LivetableComponent, LoginComponent, LoginDialogComponent, MarqueeDirective,
  MenuComponent,
  MessageComponent,
  NavbarComponent,
  NavComponent,
  NavItemDirective,
  NumberComponent,
  PageContainerDirective,
  PageContentComponent, PageDialogComponent,
  PageDirective,
  PaginationComponent,
  PanelComponent,
  PartialDirective,
  PartialParamDirective,
  PictureDirective,
  PopoverComponent,
  PrefabContainerComponent,
  PrefabDirective,
  PrefabWidgetIdDirective,
  WmxComponentDirective,
  ProgressBarComponent,
  ProgressCircleComponent,
  RadiosetComponent,
  RatingComponent,
  RepeatTemplateDirective,
  RichTextEditorComponent,
  RightPanelComponent,
  SearchComponent,
  SelectComponent,
  CustomComponent,
  SliderComponent, SpinnerComponent,
  SwitchComponent, TableActionDirective,
  TableColumnDirective,
  TableColumnGroupDirective,
  TableComponent, TableCudDirective,
  TableRowActionDirective,
  TableRowDirective,
  TabPaneComponent,
  TabsComponent,
  TextareaComponent,
  TextComponent,
  TileDirective,
  TimeComponent,
  TopNavComponent,
  TreeDirective,
  VideoComponent,
  WizardComponent,
  WizardstepComponent,
  WizardActionDirective,
  WmsTranscludeDirective,
  LinearLayoutDirective,
  LinearLayoutItemDirective,
  WmsDesignQuickActionsComponent,
  LeftPanelDirective,
  MobileNavbarComponent,
  MobileTabbarComponent,
  MobilePageDirective,
  CameraComponent,
  BarcodeScannerComponent,
  WebviewComponent,
  LottieComponent,
  BottomSheetComponent
} from "@wm/design-runtime";

export const isPrefabInPreview = (prefabName: string) => prefabName === '__self__';

export const getPrefabBaseUrl: (projectID: string, prefabName?: string) => string = (projectID: string, prefabName?: string) => environment.SERVICES_BASE_PATH +  'services/projects/' + projectID + '/resources' + (prefabName ? ('/info/web/WEB-INF/prefabs/' + prefabName + '/webapp') : '/content/web');

export const getPrefabConfigUrl = (projectID: string, prefabName?: string) => `${getPrefabBaseUrl(projectID, prefabName)}/config.json`;

export const getPrefabMinJsonUrl = (prefabName: string, projectID: string) => `${getPrefabBaseUrl(projectID, prefabName)}/pages/Main/page.min.json`;

export const getPrefabPartialJsonUrl = (prefabName: string, projectID: string, partialName?: string) => `${getPrefabBaseUrl(projectID, prefabName)}/pages/${partialName}/page.min.json`;

export const PIPES = [
    CapitalizePipe,
    FileIconClassPipe,
    FilterPipe,
    FileExtensionFromMimePipe,
    FileSizePipe,
    ToNumberPipe,
    ToDatePipe,
    ToCurrencyPipe,
    PrefixPipe,
    SuffixPipe,
    TimeFromNowPipe,
    NumberToStringPipe,
    StateClassPipe,
    StringToNumberPipe,
    TrailingZeroDecimalPipe,
    TrustAsPipe,
    ImagePipe,
    CustomPipe,
    SanitizePipe,
    OrderByPipe,
    TemplateFilter,
    TemplateReplacePipe
]
export const STANDALONE_COMPONENTS = [
    ContainerComponent,
    ButtonComponent,
    PageDirective, PageContentComponent, ContentComponent, WmsTranscludeDirective,
    CaptionPositionDirective,
    ListenPropertyDirective,
    PageContainerDirective,
    LabelDirective, PictureDirective, AnchorComponent,
    ListComponent, ListItemDirective,
    ConfirmDialogComponent, AlertDialogComponent, DialogFooterDirective,
    NumberComponent, TextComponent,
    CompositeDirective,
    IconComponent,
    CheckboxComponent,
    SliderComponent,
    CheckboxComponent,
    SelectComponent,
    ButtonGroupDirective,
    CurrencyComponent,
    TextareaComponent,
    TreeDirective,
    MenuComponent,
    CheckboxsetComponent,
    RadiosetComponent,
    ProgressBarComponent,
    SearchComponent,
    ChipsComponent,
    CarouselDirective,
    CarouselTemplateDirective,
    CustomWidgetContainerDirective,
    SwitchComponent,
    RatingComponent,
    TimeComponent,
    DateComponent,
    DateTimeComponent,
    HtmlDirective,
    PartialDirective,
    FileuploadComponent,
    ProgressCircleComponent,
    LayoutGridDirective,
    LayoutGridColumnDirective,
    LayoutGridRowDirective,
    NavComponent,
    NavItemDirective,
    NavbarComponent,
    RichTextEditorComponent,
    BreadcrumbComponent,
    ColorpickerComponent,
    TileDirective,
    AudioComponent,
    VideoComponent,
    PartialParamDirective,
    MessageComponent,
    HeaderComponent,
    LeftPanelComponent,
    FooterComponent,
    RightPanelComponent,
    TopNavComponent,
    CalendarComponent,
    IframeComponent,
    PanelComponent,
    PopoverComponent,
    PanelComponent,
    TabsComponent,
    TabPaneComponent,
    WizardComponent,
    WizardstepComponent,
    WizardActionDirective,
    AccordionDirective,
    AccordionpaneComponent,
    RepeatTemplateDirective,
    PrefabDirective,
    PrefabContainerComponent,
    PrefabWidgetIdDirective,
    WmxComponentDirective,
    PaginationComponent,
    TableComponent,
    LivetableComponent,
    TableColumnDirective,
    TableColumnGroupDirective,
    TableRowDirective,
    TableRowActionDirective,
    TableActionDirective,
    TableCudDirective,
    ChartComponent,
    FormComponent,
    FormFieldDirective,
    FormActionDirective,
    LiveFormDirective,
    DesignDialogComponent,
    IframeDialogComponent,
    LoginDialogComponent,
    PageDialogComponent,
    LiveFilterDirective,
    SpinnerComponent,
    LoginComponent,
    MarqueeDirective,
    CustomComponent,
    CardComponent,
    CardContentComponent,
    CardFooterDirective,
    LinearLayoutDirective,
    LinearLayoutItemDirective,
    WmsDesignQuickActionsComponent
];

export const RN_SPECIFIC_STANDALONE_COMPONENTS = [
  LeftPanelDirective,
  MobileNavbarComponent,
  MobileTabbarComponent,
  MobilePageDirective,
  CameraComponent,
  BarcodeScannerComponent,
  WebviewComponent,
  LottieComponent,
  BottomSheetComponent
];
